import { View } from'../../../pip/library/pi-interop/pi-interop.js';

/**
 * a view for rendering nothing
 * @todo show some kind of message that the view does not exist
 */
export class ViewEmpty extends View {}
